export enum CourierTablesTabsEnum {
  History = 'history',
  Acts = 'acts',
}
